export default {
  'components.addToCart.success.title': '成功加入购物车',
  'components.addToCart.error.title': '温馨提示',
  'components.addToCart.success.content': '去购物车提交意向单吧！',
  'components.addToCart.error.content': '加入意向单异常请联系在线客服！',
  'components.addToCart.success.okBtn': '去提交',
  'components.addToCart.success.cancelBtn': '继续逛逛',
  'components.addToCart.error.okBtn': '在线客服',
};
